import * as React from 'react';
import { Text } from '../../texts';
import { Styled } from '../styled';

const Component = () => {
  return (
    <Styled.NoResults>
      <Text color="gray">No results found</Text>
    </Styled.NoResults>
  )
};


export const NoResult = React.memo(Component);